
import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

const dropdownItems = {
    "PROJECTS": ["Abattoir", "Apples", "Avocado", "Bananas", "Beans", "Cabbages", "Kale", "Mangoes", "Onions", "Passion Fruits", "Papaya", "Potatoes", "Strawberries", "Tomatoes", "Watermelon"],
  
  };
  const Dropdown = ({ label, items, type, isProjectDropdown, bottomLabel }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [selected, setSelected] = useState(items[0]);
  
    return (
      <div className="flex flex-col w-full relative">
        {/* Button + Icon Container */}
        <label className="md:text-[24px] font-bold text-[6px] text-[#03897B]  mb-1 md:mb-14">
          {label}
        </label>
  
        <div className="flex relative z-20 w-fit">
          {/* Dropdown Button */}
          <button
            onClick={() => setIsOpen((prev) => !prev)}
            className={`xl:w-[360px] lg:w-[140px] md:w-[55px] w-[70px] h-[15px] md:h-[82px] ${
              isProjectDropdown ? "bg-[#03897B]" : "bg-[#03897B]"
            } text-white font-semibold flex md:px-3 items-center px-1 rounded-l-[5px]`}
          >
            <span className="md:text-[20px] md:px-2 text-[4px] md:mt-0 mt-[2px]">{selected}</span>
          </button>
  
          {/* Icon Box */}
          <div
            className={`w-[20px] h-[15px] md:h-[82px] md:w-[85px] ${
              isProjectDropdown ? "bg-[#F38323]" : "bg-[#F38323]"
            } text-white flex justify-center items-center rounded-r-[5px] -ml-2 z-30 cursor-pointer`}
            onClick={() => setIsOpen((prev) => !prev)}
          >
            <img
              src="https://res.cloudinary.com/dzngpgki4/image/upload/v1746113102/Expand_down_17_achr9o.png"
              alt="expand"
              className="w-2 h-2 md:w-[45px] md:h-[47px]"
            />
          </div>
        </div>
  
        {/* Dropdown List */}
        <AnimatePresence>
          {isOpen && (
            <motion.ul
              initial={{ opacity: 0, y: -10 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -10 }}
              className="absolute top-full mt-1 left-0 z-50 md:w-[180px] w-[100px] bg-white/90 rounded-lg shadow-lg"
            >
              {items.map((item, index) => (
                <li
                  key={index}
                  onClick={() => {
                    setSelected(item);
                    setIsOpen(false);
                  }}
                  className="md:p-3 p-1 bg-[#CFD7D7] md:mt-1 md:text-[18px] text-[10px] rounded-md hover:bg-[#afafaf] cursor-pointer flex items-center"
                >
                  <span className="text-black">{item}</span>
                </li>
              ))}
            </motion.ul>
          )}
        </AnimatePresence>
        <p className="md:text-[16px] text-[6px] inline font-normal mt-1 md:mt-2 text-black">
    Select <p className="lowercase  inline" > {label}</p>
  </p>
   
      </div>
    );
  };
  
const ProjectDropdown = () => {
  const keys = Object.keys(dropdownItems);
  return (
    <div>
        {/* Dropdowns */}
    <div className="md:mb-2 mb-1 md:mt-6 mt-2 font-Inter w-full mx-auto">
      <div className="grid grid-cols-2 gap-4">
        {keys.map((type, index) => {
          const customLabels = {
            Crop: "Crop Report",
            Livestock: "Livestock Report",
            Type: "Type of Report",
          };

          const bottomLabels = [
            "Select administrative location",
            "Select value chain",
            "Select administrative location",
            "Viewmore",
          ];

          const displayLabel = customLabels[type] || type;
          const isProjectDropdown = index === keys.length - 1;

          return (
            <div key={type} className="w-full">
              <Dropdown
                label={displayLabel}
                items={dropdownItems[type]}
                type={type}
                isProjectDropdown={isProjectDropdown}
                bottomLabel={bottomLabels[index]}
              />
            </div>
          );
        })}
      </div>
    </div>
    </div>
  )
}

export default ProjectDropdown